module.exports = __webpack_public_path__ + "images/feature/20151225_01-726634a0d816c24dee13a1273dc9216a.png";